module.exports = __webpack_public_path__ + "static/scale-model-of-cool-crest-family-fun-center-in-independence-missouri-f5f442c05bc7c14bfc93a88045e9cf52.png";